import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState, PriceFilterState, PriceRange } from '@immosky/types';
import { Subscription } from 'rxjs';
import {
  resetPriceFilter,
  selectPriceFilterState,
  setPriceFilter,
} from '@immosky/object-search-filter';

@Component({
  selector: 'app-price-filter-dropdown',
  templateUrl: './price-filter-dropdown.component.html',
  styleUrls: ['./price-filter-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceFilterDropdownComponent implements OnDestroy {
  currentFilterSubscription: Subscription;

  currentFilter!: PriceRange;
  appliedFilter!: PriceRange;

  isActive = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.currentFilterSubscription = this.store
      .pipe(select(selectPriceFilterState))
      .subscribe((filter: PriceFilterState) => {
        this.appliedFilter = filter.filter;
        this.isActive = filter.isActive;
        this.cdRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.currentFilterSubscription.unsubscribe();
  }

  select(filter: PriceRange) {
    this.currentFilter = filter;
  }

  applyChanges() {
    this.store.dispatch(
      setPriceFilter({
        filter: this.currentFilter,
      })
    );
  }

  reset() {
    this.store.dispatch(resetPriceFilter());
  }
}
